module.exports = "<h1>{{ title }}</h1>\n<app-books></app-books>\n"


//////////////////
// WEBPACK FOOTER
// /home/shalom/sandbox/kidlendinglibrary/kidlendinglibrary/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main